import AppProvider from "@/components/providers/AppProvider";
import { createRoot } from "react-dom/client";
import "./index.less";
import Router from "./routers";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <AppProvider>
    <Router />
  </AppProvider>,
);

const m: any = module;
if (m.hot) {
  m.hot.accept();
}
